import React from 'react';

type TblListProps = {
    children: React.ReactNode;
    noSpacing?: boolean;
};

/**
 * Wrapper for the standard table-list section.
 * Use `noSpacing` for nested/detail tables that sit inside another container.
 */
const TableList = ({ children, noSpacing = false }: TblListProps): JSX.Element => {
    const className = `v2-table table-list${noSpacing ? ' no-spacing' : ''}`;
    return <section className={className}>{children}</section>;
};

export default TableList;
